import { render, staticRenderFns } from "./company_details.vue?vue&type=template&id=1cc9ddac&scoped=true&"
import script from "./company_details.vue?vue&type=script&lang=js&"
export * from "./company_details.vue?vue&type=script&lang=js&"
import style0 from "./company_details.vue?vue&type=style&index=0&id=1cc9ddac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9ddac",
  null
  
)

export default component.exports